/**
 * The profile affordance (found missing 4 Sep 2026): who is signed in, their e-mail, the entity line, the console link for the
 * factura-admin role, and Cerrar sesión → /.auth/logout (Static Web Apps ends the session there; nothing else is needed).
 * Not an artboard: a sheet opened from the name in the app header, and a card in the console's sidebar (screen 11).
 */
import { useState, type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { call } from '../api/client.ts';
import { useLoad } from '../state/hooks.ts';
import { logoutUrl } from '../state/auth.ts';
import { Icon, Sheet } from '../theme/ui.tsx';
import type { Session } from '../App.tsx';

export function ProfileCard({ session }: { session: Session }) {
  const me = useLoad(() => call('me.get'), []);
  const ents = useLoad(() => call('entities.list'), []);
  const entity = ents.data?.entities.find((e) => e.entityId === me.data?.entityId);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <div style={{ fontSize: 15, fontWeight: 600, letterSpacing: '-0.008em' }}>{session.displayName}</div>
      <div className="sub" style={{ overflowWrap: 'anywhere' }}>{session.email}</div>
      {me.data && <div className="sub">{entity ? <>{entity.name} · <span className="mono">{entity.rfc}</span></> : 'Sin empresa elegida'}</div>}
    </div>
  );
}

/** [the sheet to render, open it] — like useToast. */
export function useProfile(session: Session): [ReactNode, () => void] {
  const [open, setOpen] = useState(false);
  const sheet = open ? (
    <Sheet onClose={() => setOpen(false)}>
      <ProfileCard session={session} />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {session.isOperator && <Link to="/operador" className="btn btn--secondary btn--sm" onClick={() => setOpen(false)}><Icon.Inbox size={17} width={1.8} />Cola del operador</Link>}
        <Link to="/datos-fiscales" className="btn btn--secondary btn--sm" onClick={() => setOpen(false)}><Icon.Qr size={17} width={1.8} />Datos de facturación</Link>
        <a href={logoutUrl} className="btn btn--ghost btn--sm"><Icon.Logout size={17} width={1.8} />Cerrar sesión</a>
      </div>
    </Sheet>
  ) : null;
  return [sheet, () => setOpen(true)];
}
